export default "__VITE_ASSET__vaxgXIXu__"